import React from "react";
import { Box } from '@mui/joy';
import { Bar } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import PieSet from "./PieSet";
import KPISet from "./KPISet";

const Page = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showPIE = true;
    const showTimelineLead = false;


    const getTransposedDate = (months) => {
        const today = new Date();
        today.setMonth(today.getMonth() + months);

        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
    }

    const createTimelineBarFilterHandler = (field, addFilter) => (params) => {
        const [monthStr, yearStr] = params.split(' ');
        const month = parseInt(monthStr, 10) - 1;
        const year = parseInt(yearStr, 10);

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);

        addFilter(field, params);
    };

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Budget Locale')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <KPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showPIE &&
                <PieSet dataProviderName={dataProviderName} filters={filters} />
            }

        </Box>
    )
}

export default Page;